/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerTriggerSyncMutationRequest, TransferCustomersControllerTriggerSyncMutationResponse } from "../../models/transferCustomersController/TransferCustomersControllerTriggerSync";

function getTransferCustomersControllerTriggerSyncUrl() {
  const res = { method: 'POST', url: `/api/v1/transfer-customers/sync` as const }  
  return res
}

/**
 * @summary Trigger customer data sync from Redshift to DC 2 database
 * {@link /api/v1/transfer-customers/sync}
 */
export async function transferCustomersControllerTriggerSync(data?: TransferCustomersControllerTriggerSyncMutationRequest, config: Partial<RequestConfig<TransferCustomersControllerTriggerSyncMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransferCustomersControllerTriggerSyncMutationResponse, ResponseErrorConfig<Error>, TransferCustomersControllerTriggerSyncMutationRequest>({ method : "POST", url : getTransferCustomersControllerTriggerSyncUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}